import { render } from "./PurchaseOrders.vue?vue&type=template&id=106888f4&scoped=true&ts=true"
import script from "./PurchaseOrders.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrders.vue?vue&type=script&lang=ts"

import "./PurchaseOrders.vue?vue&type=style&index=0&id=106888f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106888f4"]])

export default __exports__